module.exports = __webpack_public_path__ + "static/img/6259_phase_function_Paper_PointsHejduk_Prediction.52847db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6259_phase_function_Paper_PointsHejduk_Prediction.png
// module id = b+Dm
// module chunks = 0